import moment from 'moment';
import printJS from 'print-js';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addWbProducts } from '../../../../actions/wb';
import MarketWbApi from '../../../../API/market/wb-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { Switch } from '../../../../components/Basic/Elements';
import { DateInput, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { Table, TableHeader } from '../../../../components/Basic/Table';
import { Text, TextGrey } from '../../../../components/Basic/WrapsStyle';
import { MarketsSearch, MarketsTable } from '../../../../components/Markets';
import MarketsFilter, { FRONT_ERRORS, FRONT_WARNING } from '../../../../components/Markets/Blocks/Filter';
import { MARKETS_MAP, TYPE_BUTTONS } from '../../../../constans';
import { numberWithSpaces } from '../../../../utils';
import styles from './styles.module.scss';

const width = [
  '70px', //0
  '200px', //1
  '300px', //2
  '100px', //3
  '100px', //4
  '60px', //5
  '150px', //6
  '180px', //7
  '200px', //8
  '150px', //9
  '120px', //10
  '50px', //11
];

const FILTER_STOCKS = {
  0: 'all',
  1: 'instock',
  2: 'nullstock',
  3: 'warehouse',
  4: 'mpwarehouse',
  5: 'is_express',
  6: 'is_cc',
  7: 'isminus',
  8: 'error',
  9: 'warning',
  10: 'notupdated',
};

const FILTER_CONTENT = {
  0: 'all',
  1: 'not_sales',
  2: 'not_images',
  3: 'stopbrand',
  4: 'outofstock',
  5: 'basket',
  6: 'deleted',
};

const FILTER_STOCKS_FBS = {
  0: 'all',
  1: 'instock',
};

const FILTER = {
  'Режим остатков': FILTER_STOCKS,
  'Режим цен': FILTER_STOCKS,
  'Режим контента': FILTER_CONTENT,
  'Режим FBS': FILTER_STOCKS_FBS,
};

const MODES = ['Режим остатков', 'Режим цен', 'Режим контента', 'Режим FBS'];

const NAVIGATE = {
  'Режим остатков': [
    'Все товары',
    'В продаже',
    'Готовы к продаже',
    'На нашем складе',
    'На складе wb',
    'Экспресс',
    'Самовывоз',
    'В минус',
    'С ошибками',
    'Предупреждение',
    'Не обновлено',
  ],
  'Режим цен': [
    'Все товары',
    'В продаже',
    'Готовы к продаже',
    'На нашем складе',
    'На складе wb',
    'Экспресс',
    'Самовывоз',
    'В минус',
    'С ошибками',
    'Предупреждение',
    'Не обновлено',
  ],
  'Режим контента': [
    'Все товары',
    'Карточки без продаж',
    'Карточки без фото',
    'Стоп бренды',
    'Выведено из ассортимента',
    'Корзина',
    'Удаленно',
  ],
  'Режим FBS': ['Все товары', 'В продаже'],
};

let abortController = new AbortController();

const NUM_SALES = [
  { text: 'Не выбран', value: undefined },
  { text: 'Продаж не было', value: 0 },
  { text: 'Продажи были', value: -1 },
  { text: 'Одна продажа', value: 1 },
  { text: 'Две продажи', value: 2 },
  { text: 'Больше 5', value: 5 },
  { text: 'Больше 10', value: 10 },
  { text: 'Больше 25', value: 25 },
  { text: 'Больше 50', value: 50 },
  { text: 'Больше 100', value: 100 },
];

const SORT_TYPE = [
  { text: 'Не выбран', value: undefined },
  { text: 'Кол-во заказов', value: 'grow_sales' },
];

const LAST_SALES = [
  { text: 'Не выбран', value: undefined },
  { text: 'Недавно', value: -7 },
  { text: 'Больше месяца', value: 30 },
  { text: 'Больше 2х месяцев', value: 60 },
  { text: 'Больше 3х месяцев', value: 90 },
  { text: 'Больше 6и месяцев', value: 180 },
  { text: 'Больше года', value: 365 },
];
const DATE_CREATE = [
  { text: 'Не выбран', value: undefined },
  { text: 'Больше месяца', value: 30 },
  { text: 'Больше 2х месяцев', value: 60 },
  { text: 'Больше 3х месяцев', value: 90 },
  { text: 'Больше 6и месяцев', value: 180 },
  { text: 'Больше года', value: 365 },
];
const STOCKS = [
  { text: 'Не выбран', value: undefined },
  { text: 'Да', value: true },
  { text: 'Нет', value: false },
];

const STOCKS_SKLAD = {
  stock_msk: 'msk',
  stock_ekb: 'ekb',
};
const WbTable = ({
  isFbsRemainsMode = false,
  setIsFbsRemainsMode,
  showPriceControl = false,
  showSale = false,
  updateProviderStocksAndPrice = () => {},
  updateProviderPrice = () => {},
  parentUpdate,
  ...props
}) => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [empty, setEmpty] = useState(false);

  const allProviders = useSelector((store) => store.providers);
  const [provider, changeProvider] = useState({ name: 'Не выбран', id: null });
  const [numSales, changeNumSales] = useState({ text: 'Не выбран', value: undefined });
  const [sortType, changeSortType] = useState({ text: 'Не выбран', value: undefined });
  const [lastSales, changeLastSales] = useState({ text: 'Не выбран', value: undefined });
  const [dateCreate, changeDateCreate] = useState({ text: 'Не выбран', value: undefined });
  const [page, setPage] = useState(1);
  const [profitStatistic, setProfitStatistic] = useState({});
  const [sizesMode, setSizesMode] = useState(false);

  const [providers, setProviders] = useState([]);

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [period, setPeriod] = useState({
    start: new Date(moment().subtract(5, 'M')),
    end: new Date(moment().add(1, 'day')),
  });

  const [error, setError] = useState(Object.keys(FRONT_ERRORS)[0]);
  const [warning, setWarning] = useState(Object.keys(FRONT_WARNING)[0]);
  const [productsSelect, setProductsSelect] = useState({});
  const [checkAll, setCheckAll] = useState(false);

  const [contentMode, changeMode] = useState(isFbsRemainsMode ? MODES[3] : MODES[0]);
  const [wbStock, setWbStock] = useState(STOCKS[0]);
  const [warehouseStock, setWarehouseStock] = useState(STOCKS[0]);
  const [errorsGroup, setErrorsGroup] = useState({});
  const [warningsGroup, setWarningsGroup] = useState({});

  const [cards, setCards] = useState({ ids: [], byId: {} });

  const shop = useSelector((store) => store.wb.market);
  const [pricesMode, setPricesMode] = useState(true);

  const { role } = useSelector((store) => store.user);
  const dispatch = useDispatch();

  const onChangeProduct = async (offer_id, key, value, skladName) => {
    if (cards.byId[offer_id][key] === value) {
      return;
    }
    let setCard = (card) => {
      setCards({ ...cards, byId: { ...cards.byId, [offer_id]: { ...cards.byId[card.offer_id], ...card } } });
    };
    if (key === 'stock') {
      return await MarketWbApi.changeStock({
        data: { shop: MARKETS_MAP[shop], offer_id, value: parseInt(value), skladName },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'price' || key === 'discount') {
      return await MarketWbApi.changePrice({
        data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'percent' || key === 'min_rub') {
      return await MarketWbApi.changeMarginality({
        data: { shop: MARKETS_MAP[shop], offer_id, field: key, value: parseInt(value) },
      })
        .then((r) => {
          setCard(r.card);
        })
        .catch((e) => console.log(e));
    }
    if (key === 'stopbrand') {
      return await MarketWbApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds: [offer_id], value } })
        .then((r) => {
          //setCard(card);
          loadCards();
        })
        .catch((e) => console.log(e));
    }
    return await MarketWbApi.changeCard({ data: { shop: MARKETS_MAP[shop], offer_id, field: key, value } })
      .then((r) => {
        setCard(r.card);
      })
      .catch((e) => console.log(e));
  };

  const onChangeCards = async (offerIds, key, value) => {
    if (key === 'stopbrand') {
      return await MarketWbApi.changeStopBrand({ data: { shop: MARKETS_MAP[shop], offerIds, value } })
        .then(() => {
          loadCards();
        })
        .catch((e) => console.log(e));
    }

    if (key === 'basket') {
      return await MarketWbApi.changeBasket({ data: { shop: MARKETS_MAP[shop], offerIds, value } }).then(() => {
        loadCards();
      });
    }
    if (key === 'images') {
      return await MarketWbApi.loadAiImage({ data: { shop: MARKETS_MAP[shop], offerIds } }).then(() => {
        // loadCards();
      });
    }

    // if (key === 'stock') {
    //   return await updateProviderStocksAndPrice(undefined, value, offerIds).then(() => {
    //     setCheckAll(false);
    //     setProductsSelect({});
    //   });
    // }

    if (key === 'price') {
      return await updateProviderPrice(undefined, offerIds, true, true).then(() => {
        setCheckAll(false);
        setProductsSelect({});
        loadCards();
      });
    }
  };

  const printSticker = async (offerId, quantity) => {
    let file = await MarketWbApi.fboSticker({ data: { offerId, shop: MARKETS_MAP[shop], quantity } });

    printJS({
      printable: file,
      type: 'pdf',
      base64: true,
      showModal: false,
      onPrintDialogClose: () => {
        window.focus();
      },
    });
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onChangePage = (v) => {
    setPage(v);
  };

  const params = useMemo(() => {
    return {
      search: search.trim(),
      limit: parseInt(show),
      page,
      shop: MARKETS_MAP[shop],
      providerId: provider.id,
      tab: FILTER[contentMode][tab],
      isFbsRemainsMode: isFbsRemainsMode,
      filters: {
        sortType: sortType.value,
        errorType: error === 'null' ? null : error,
        warningType: warning === 'null' ? null : warning,
        numSales: numSales.value,
        warehouseWbStock: wbStock.value,
        warehouseStock: warehouseStock.value,
        lastSale: lastSales.value,
        dateCreate: dateCreate.value,
        period,
      },
    };
  }, [
    search,
    show,
    shop,
    page,
    tab,
    provider,
    contentMode,
    numSales,
    wbStock,
    warehouseStock,
    lastSales,
    dateCreate,
    error,
    warning,
    isFbsRemainsMode,
    period,
    sortType,
  ]);

  const params_excel = useMemo(() => {
    return {
      ...params,
      limit: undefined,
      page: undefined,
    };
  }, [params]);

  const loadCards = () => {
    abortController.abort(); // Cancel the previous request
    abortController = new AbortController();

    MarketWbApi.getCardsBySearch({ data: params, signal: abortController.signal }).then((r) => {
      const {
        all,
        instock,
        notsales,
        stopstock,
        nullstock,
        warehousestock,
        mpstock,
        isminusstock,
        outofstock,
        basketstock = 0,
        deletedstocks = 0,
        notupdated,
        notimages,
        is_express,
        warningstock,
        errostock,
        is_cc,
      } = r.stock;

      setCount(r.stock.count);
      if (contentMode === MODES[0] || contentMode === MODES[1]) {
        setCountStock([
          all,
          instock,
          nullstock,
          warehousestock,
          mpstock,
          is_express,
          is_cc,
          isminusstock,
          errostock,
          warningstock,
          notupdated,
        ]);
      }
      if (contentMode === MODES[2]) {
        setCountStock([all, notsales, notimages, stopstock, outofstock, basketstock, deletedstocks]);
      }
      if (contentMode === MODES[3]) {
        setCountStock([all, instock]);
      }
      const byIds = {};
      const id = r.cards.map((item) => item.offer_id);
      r.cards.forEach((item) => (byIds[item.offer_id] = item));

      setCards({ byId: byIds, ids: id });
      setCheckAll(false);
      setErrorsGroup(r.errorsGroup);
      setWarningsGroup(r.warningsGroup);
      setProfitStatistic(r.profitStatistic);
      setProductsSelect({});
      // setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...allProviders]);
      const p = allProviders.filter((item) => r.providersIdsInShipments?.includes(item.id));
      setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...p] || allProviders);
    });
  };

  useEffect(() => {
    loadCards();
    return () => dispatch(addWbProducts({ byId: {}, ids: [] }));
  }, [params, parentUpdate]);

  // useEffect(() => {
  //   const p = allProviders.filter((item) => !item.hide);
  //   if (p.length > 0) {
  //     setProviders([{ name: 'Не выбран', id: null }, { name: 'Не заполнен', id: -1 }, ...p]);
  //     changeProvider({ name: 'Не выбран', id: null });
  //   } else {
  //     changeProvider({ name: '' });
  //   }
  // }, [allProviders]);

  const changeProductSelect = (artnumber) => {
    if (productsSelect[artnumber]) {
      const s = productsSelect;
      delete s[artnumber];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [artnumber]: true });
    }
  };

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      cards.ids.forEach((item) => {
        map_select[cards.byId[item].offer_id] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const colorByPercent = (perc) => {
    if (perc >= 90) return '#168600ff';
    if (perc >= 80) return '#56b601ff';
    if (perc >= 70) return '#99aa00ff';
    if (perc >= 60) return '#aa6c00ff';
    return '#aa0000ff';
  };

  useEffect(() => {
    setError(Object.keys(FRONT_ERRORS)[0]);
    setWarning(Object.keys(FRONT_WARNING)[0]);
    setCheckAll(false);
    setProductsSelect({});
  }, [tab]);

  const isContentUser = role === 'user';
  const isOwner = role === 'owner' || role === 'admin';

  const isSelectAllowed =
    isOwner || (isContentUser && contentMode === MODES[1] && (tab === 1 || tab === 2 || tab === 3 || tab === 4));

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={NAVIGATE[contentMode]}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />

          <div>
            <Select
              select={contentMode}
              list={MODES}
              onSelect={(v) => {
                changeMode(v);
                setTab(0);
                setIsFbsRemainsMode(v === MODES[3]);
              }}
              width="150px"
            />
          </div>
        </Row>

        <MarketsSearch
          market={'WB'}
          selectTab={FILTER[contentMode][tab]}
          search={search}
          productsSelect={productsSelect}
          setSearch={setSearch}
          setCheckAll={setCheckAll}
          setProductsSelect={setProductsSelect}
          count={count}
          onArchive={(offerIds, state) => onChangeCards(offerIds, 'archive', state)}
          onStopbrand={(offerIds, state) => onChangeCards(offerIds, 'stopbrand', state)}
          updateStocks={(offerIds, state) => onChangeCards(offerIds, 'stock', state)}
          updatePrices={(offerIds) => onChangeCards(offerIds, 'price')}
          toBasket={(offerIds, state) => onChangeCards(offerIds, 'basket', state)}
          updateImages={(offerIds) => onChangeCards(offerIds, 'images')}
        />

        <Row spaceBetween={true}>
          <Row>
            <MarketsFilter
              selectTab={FILTER[contentMode][tab]}
              show={show}
              tab={tab}
              provider={provider}
              providers={providers}
              error={error}
              setShow={setShow}
              setError={setError}
              setWarning={setWarning}
              changeProvider={changeProvider}
              errorsGroup={errorsGroup}
              warningsGroup={warningsGroup}
            />
            {contentMode === MODES[0] && (
              <div style={{ marginLeft: '15px' }}>
                <Select
                  label="Сортировать по"
                  select={sortType}
                  valueFn={(p) => p.text}
                  list={SORT_TYPE}
                  width="200px"
                  onSelect={(v) => changeSortType(v)}
                />
              </div>
            )}

            {contentMode === MODES[3] && (
              <Row>
                <Column style={{ marginRight: '10px' }}>
                  <InputLabel>Начало периода</InputLabel>
                  <Row style={{ width: '130px' }}>
                    <DateInput
                      value={period.start}
                      className={styles.calendar}
                      onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                    />
                  </Row>
                </Column>
                <Column style={{ marginRight: '10px' }}>
                  <InputLabel>Конец периода</InputLabel>
                  <Row style={{ width: '130px' }}>
                    <DateInput
                      value={period.end}
                      className={styles.calendar}
                      onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                    />
                  </Row>
                </Column>
              </Row>
            )}

            {contentMode === MODES[1] && tab !== 1 && (
              <>
                <div style={{ marginLeft: '15px' }}>
                  <Select
                    label="Количество продаж"
                    select={numSales}
                    valueFn={(p) => p.text}
                    list={NUM_SALES}
                    width="200px"
                    onSelect={(v) => changeNumSales(v)}
                  />
                </div>
                <div style={{ marginLeft: '15px' }}>
                  <Select
                    label="Последня продажа"
                    select={lastSales}
                    valueFn={(p) => p.text}
                    list={LAST_SALES}
                    width="200px"
                    onSelect={(v) => changeLastSales(v)}
                  />
                </div>
                <div style={{ marginLeft: '15px' }}>
                  <Select
                    label="Карточка создана"
                    select={dateCreate}
                    valueFn={(p) => p.text}
                    list={DATE_CREATE}
                    width="200px"
                    onSelect={(v) => changeDateCreate(v)}
                  />
                </div>
                <div style={{ marginLeft: '15px' }}>
                  <Select
                    label="Есть остаток на складе вб"
                    select={wbStock}
                    valueFn={(p) => p.text}
                    list={STOCKS}
                    width="200px"
                    onSelect={(v) => setWbStock(v)}
                  />
                </div>
                <div style={{ marginLeft: '15px' }}>
                  <Select
                    label="Есть остаток на нашем складе"
                    select={warehouseStock}
                    valueFn={(p) => p.text}
                    list={STOCKS}
                    width="200px"
                    onSelect={(v) => setWarehouseStock(v)}
                  />
                </div>
              </>
            )}
          </Row>

          {contentMode === MODES[3] ? (
            <Row>
              <Row style={{ width: '180px', marginRight: '5px' }}>
                <TextGrey style={{ marginRight: '10px' }}>Показать цены</TextGrey>
                <Switch switched={pricesMode} onClick={(v) => setPricesMode(v)} />
              </Row>
              <Row style={{ width: '200px', marginRight: '5px' }}>
                <TextGrey style={{ marginRight: '10px' }}>Показать габариты</TextGrey>
                <Switch switched={sizesMode} onClick={(v) => setSizesMode(v)} />
              </Row>
            </Row>
          ) : (
            <Column className={styles.column_button}>
              <Row>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketWbApi.excelData({ data: params_excel })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать данные
                </Button>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketWbApi.excelAnalytics({ data: params_excel })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать аналитику
                </Button>
              </Row>
            </Column>
          )}
        </Row>
      </WhiteBlock>
      {isOwner && contentMode === MODES[3] && (
        <Table style={{ overflow: 'auto', minHeight: 'max-content' }}>
          <TableHeader whiteHeader>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Итоговая прибыль по отчету: </TextGrey>
              <Text
                fontSize={'19px'}
                style={{ color: profitStatistic?.total_profit_by_report > 0 ? '#01800eca' : '#6e0000d9' }}
                className={styles.profit}
              >
                {numberWithSpaces(Math.ceil(profitStatistic?.total_profit_by_report))} руб. -{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.total_count_by_report))} заказов
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>В пути (без отчета): </TextGrey>
              {/* <Text style={{ color: '#70942cc5' }} className={styles.profit}>{numberWithSpaces(Math.ceil(profitStatistic?.total_profit - profitStatistic?.total_profit_by_report))} руб. - {numberWithSpaces(Math.ceil(profitStatistic?.total_count - profitStatistic?.sold_count_by_report))} заказов</Text> */}
              <Text style={{ color: '#70942cc5' }} className={styles.profit}>{numberWithSpaces(Math.ceil(profitStatistic?.delivery_profit))} руб. - {numberWithSpaces(Math.ceil(profitStatistic?.delivery_count))} заказов</Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Реализованная закупка / всего:</TextGrey>
              <Text style={{ color: '#603b01c3' }} className={styles.profit}>
                {numberWithSpaces(Math.ceil(profitStatistic?.total_purchase_by_report))} руб. /{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.total_purchase))} руб.
              </Text>
            </Row>
            {/* <Row className={styles.block_calc}>
                      <TextGrey className={styles.text_grey}>Всего закупка: </TextGrey>
                      <Text style={{ color: '#603b01c3' }} className={cn(styles.profit)}>{numberWithSpaces(Math.ceil(profitStatistic?.total_purchase))} руб.</Text>
                    </Row> */}
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Процент выкупа: </TextGrey>
              <Text
                fontSize={'20px'}
                style={{
                  color: colorByPercent(
                    (profitStatistic?.sold_count_by_report * 100) / profitStatistic?.total_count_by_report,
                  ),
                }}
                className={styles.profit}
              >
                {+((profitStatistic?.sold_count_by_report * 100) / profitStatistic?.total_count_by_report).toFixed(2) ||
                  '-'}{' '}
                %
              </Text>
            </Row>

            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Маржинальность: </TextGrey>
              <Text fontSize={'20px'} style={{ color: '#838f01ad' }} className={styles.profit}>
                {+((profitStatistic?.total_profit_by_report * 100) / profitStatistic?.total_purchase_by_report).toFixed(
                  2,
                ) || '-'}{' '}
                %
              </Text>
            </Row>
          </TableHeader>
          <TableHeader whiteHeader>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Отмены по отчету: </TextGrey>
              <Text style={{ color: '#6e0000bd' }} className={styles.profit}>
                {numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit_by_report))} руб. (
                {numberWithSpaces(Math.ceil(profitStatistic?.cancel_profit))} руб.) -{' '}
                {numberWithSpaces(Math.ceil(profitStatistic?.cancel_count_by_report))} заказов
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Закупка бракованого товара: </TextGrey>
              <Text style={{ color: '#6e0000bd' }} className={styles.profit}>
                -{numberWithSpaces(Math.ceil(profitStatistic?.cancel_return_pvz_purchase_by_report))} руб.
              </Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Возврат заблокированного товара: </TextGrey>
              <Text style={{ color: '#950202c3' }} className={styles.profit}>
                -{numberWithSpaces(Math.ceil(profitStatistic?.total_return_blocked))} руб.
              </Text>
            </Row>
            {/* <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Доступный заработок: </TextGrey>
              <Text style={{ color: '#6a6e00bd' }} className={styles.profit}>{numberWithSpaces(Math.ceil(potentialProfit))} руб.</Text>
            </Row> */}
          </TableHeader>
          {/* <TableHeader whiteHeader>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Хранение всего: </TextGrey>
              <Text style={{ color: '#603b01c3' }} className={styles.profit}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage))} руб.</Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Хранение сегодня: </TextGrey>
              <Text style={{ color: '#603b01c3' }} className={styles.profit}>-{numberWithSpaces(Math.ceil(storageStatistic?.total_storage_today))} руб.</Text>
            </Row>
            <Row className={styles.block_calc}>
              <TextGrey className={styles.text_grey}>Хранение в пвз: </TextGrey>
              <Text style={{ color: '#950202c3' }} className={styles.profit}>-{numberWithSpaces(Math.ceil(profitStatistic?.cancel_pvz_storage_by_report))} руб.</Text>
            </Row>
          </TableHeader> */}
        </Table>
      )}
      <MarketsTable
        market={'WB'}
        sizesMode={sizesMode}
        pricesMode={pricesMode}
        printSticker={printSticker}
        contentMode={contentMode}
        checkAll={checkAll}
        clickCheckAll={clickCheckAll}
        isOwner={isOwner}
        isExpress={false}
        cards={cards}
        count={count}
        show={show}
        page={page}
        selectTab={FILTER[contentMode][tab]}
        productsSelect={productsSelect}
        onChangePage={onChangePage}
        changeProductSelect={changeProductSelect}
        onChangeProduct={onChangeProduct}
      />
    </>
  );
};

export default WbTable;
